import React from 'react';
import TogeBot from './TogeBot';

// The homepage's TOGΞ banner: TOGΞ is available for your Discord server, with example alerts (Discord-style, all CSS)
// popping up one after another around it, and each brand's icon lighting up as its alert pops up. Opens the Discord page.

const TWITCH = <svg viewBox="0 0 24 24" fill="currentColor"><path d="M4.3 3 3 6.4v13.2h4.6V22h2.6l2.4-2.4h3.7l5-5V3H4.3Zm15.4 10.8-2.9 2.9h-4.6l-2.4 2.4v-2.4H5.9V4.7h13.8v9.1ZM16.8 7.8v5h-1.7v-5h1.7Zm-4.6 0v5h-1.7v-5h1.7Z" /></svg>;
const YOUTUBE = <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8ZM9.6 15.6V8.4l6.2 3.6-6.2 3.6Z" /></svg>;
const WHATNOT = <img src="/wnlogo.png" alt="" />; // the site's own Whatnot app icon (already the yellow tile)

// In this order everywhere: Whatnot, Twitch, YouTube. Each is drawn the way TOGΞ really posts it: Whatnot's and
// Twitch's own alert embeds (same fields and footers as the bot), and YouTube's link card (TOGΞ posts the video's link,
// so Discord shows its player)
const ALERTS = [
  {
    id: 'whatnot', label: 'Whatnot', color: '#fbe510', icon: WHATNOT, logo: WHATNOT, tile: true,
    heading: 'big', name: 'Cheeks', sub: 'Singles from £1 + giveaways!',
    author: '@cheeks', title: '🔴 Cheeks is LIVE on Whatnot!', description: 'Singles from £1 + giveaways!',
    fields: [['👀 Current views', '128'], ['📈 Max views', '156'], ['⏱️ Live for', '1h 12m'], ['👥 Followers', '2,340']],
    thumb: 'linear-gradient(135deg, #2a2400 0%, #8a7a00 50%, #fbe510 100%)', badge: 'LIVE', watching: '128',
    footer: 'CHΞΞKSCORD • 📸 Live snapshot • Updates every 5 minutes', button: 'Watch on Whatnot',
  },
  {
    // A new product in their Whatnot shop: the same big heading, then the listing
    id: 'whatnot-product', label: 'Whatnot', color: '#fbe510', product: true, icon: WHATNOT,
    heading: 'big', name: 'Cheeks',
    author: '@cheeks', title: '🆕 New listing from Cheeks', description: 'Charizard ex SIR · PSA 10',
    subtitle: 'Obsidian Flames 223/197',
    fields: [['💰 Price', '£249.99'], ['🏷️ Type', 'Buy It Now'], ['📦 Quantity', '1']],
    footer: 'CHΞΞKSCORD', button: 'View on Whatnot',
  },
  {
    id: 'twitch', label: 'Twitch', color: '#9146ff', icon: TWITCH, logo: TWITCH, logoColor: '#fff',
    heading: 'big', name: 'Cheeks',
    author: 'Cheeks', title: '🔴 Cheeks is live on Twitch!', description: 'Opening a booster box!',
    fields: [['🎮 Playing', 'Pokémon TCG'], ['👀 Viewers', '96'], ['⏱️ Live for', '42m']],
    thumb: 'linear-gradient(135deg, #2b1a55 0%, #9146ff 55%, #c9a7ff 100%)', badge: 'LIVE', watching: '96',
    footer: 'CHΞΞKSCORD • Updates every 3 minutes', button: 'Watch on Twitch',
  },
  {
    id: 'youtube', label: 'YouTube', color: '#ff0000', icon: YOUTUBE, logo: YOUTUBE, logoColor: '#fff',
    heading: 'big', name: 'Cheeks', link: 'https://www.youtube.com/watch?v=…',
    card: true, provider: 'YouTube', author: 'Cheeks', title: 'Pulling a gold star?!',
    thumb: 'linear-gradient(135deg, #1a0606 0%, #7a1010 50%, #ff4d4d 100%)', duration: '12:48',
  },
];

function Alert({ alert, avatar }) {
  return (
    <div className="tg-msg">
      <div className="flex items-center gap-1">
        {avatar
          ? <img src={avatar} alt="" className="tg-av" />
          : <span className="tg-av" style={{ background: '#5865f2' }} />}
        <span className="text-white font-semibold" style={{ fontSize: '7px' }}>TOGΞ</span>
        <span className="tg-app">APP</span>
        <span style={{ fontSize: '5.5px', color: '#949ba4' }}>Today at 19:02</span>
      </div>

      {/* The text above the embed, as each cog writes it */}
      {/* '# :icon: name' (all four), then Whatnot's live alert adds the show title on the line under it */}
      <p className="tg-head"><span className="tg-icon" style={{ color: alert.color }}>{alert.icon}</span>{alert.name}</p>
      {alert.sub && <p className="tg-sub">{alert.sub}</p>}
      {alert.link && <p className="tg-link">{alert.link}</p>}

      {alert.card ? (
        // YouTube: Discord's own video card
        <div className="tg-embed" style={{ borderLeftColor: alert.color }}>
          <p className="tg-provider">{alert.provider}</p>
          <p className="tg-author-name">{alert.author}</p>
          <p className="tg-title">{alert.title}</p>
          <div className="tg-thumb" style={{ background: alert.thumb }}>
            <span className="tg-play"><span /></span>
            <span className="tg-duration">{alert.duration}</span>
          </div>
        </div>
      ) : (
        <div className="tg-embed" style={{ borderLeftColor: alert.color }}>
          <div className="flex gap-1.5">
            <div className="min-w-0 flex-1">
              <p className="tg-author"><span className="tg-pfp xs" />{alert.author}</p>
              <p className="tg-title">{alert.title}</p>
              <p className="tg-desc">{alert.description}</p>
              {alert.subtitle && <p className="tg-subtitle">{alert.subtitle}</p>}
            </div>
            {!alert.product && <span className="tg-pfp" />}
          </div>
          <div className="tg-fields">
            {alert.fields.map(([name, value]) => (
              <div key={name}><p className="tg-fname">{name}</p><p className="tg-fval">{value}</p></div>
            ))}
          </div>
          {alert.product ? (
            // The product photo: a graded card in its slab
            <div className="tg-thumb tg-photo">
              <div className="tg-slab">
                <div className="tg-slab-label"><span>PSA</span><b>10</b></div>
                <div className="tg-card"><img src="/pball.svg" alt="" /></div>
              </div>
            </div>
          ) : (
            <div className="tg-thumb" style={{ background: alert.thumb }}>
              <span className="tg-thumb-logo">{alert.logo}</span>
              <span className="tg-badge">● {alert.badge}</span>
              <span className="tg-watching">👁 {alert.watching}</span>
            </div>
          )}
          <p className="tg-footer">{alert.footer} • Today at 19:02</p>
        </div>
      )}
      {alert.button && <span className="tg-btn"><span className="tg-btn-icon">{alert.icon}</span>{alert.button}<span style={{ opacity: 0.6 }}>↗</span></span>}
    </div>
  );
}

export default function TogeAdvert({ avatar, onOpen, onDashboard }) {
  return (
    <a href="#discord" onClick={(e) => { e.preventDefault(); onOpen(); }}
      className="tg-banner group relative block rounded-2xl overflow-hidden border border-zinc-700/70 hover:border-[#5865f2]/80 corner-glow shadow-[0_6px_24px_rgba(0,0,0,0.5)] transition-colors"
      aria-label="TOGΞ is now available for your Discord server: find out more">
      <style>{`
        .tg-banner { background:
          radial-gradient(120% 90% at 50% 0%, rgba(88,101,242,0.35) 0%, rgba(88,101,242,0) 60%),
          radial-gradient(circle at 1px 1px, rgba(255,255,255,0.06) 1px, transparent 0) 0 0 / 14px 14px,
          linear-gradient(180deg, #17181c 0%, #0b0b0d 100%); }
        /* One alert at a time, in the middle: all four share one grid cell (so the panel is as tall as the tallest
           and never jumps), and take turns, 5 seconds each, over a 20 second loop, with a clear gap between them */
        .tg-stage { display: grid; justify-items: center; align-items: center; padding: 4px 0 10px; }
        .tg-slot { grid-area: 1 / 1; animation: tgTurn 20s ease-in-out infinite both; }
        .tg-slot:nth-child(1) { --r: -1.5deg; animation-delay: 0s; }
        .tg-slot:nth-child(2) { --r: 1deg; animation-delay: 5s; }
        .tg-slot:nth-child(3) { --r: -1deg; animation-delay: 10s; }
        .tg-slot:nth-child(4) { --r: 1.5deg; animation-delay: 15s; }
        .tg-size { width: 172px; zoom: 1.45; }
        @media (min-width: 520px) { .tg-size { zoom: 1.7; } }
        @keyframes tgTurn {
          0%, 1%    { opacity: 0; transform: translateY(16px) scale(0.94) rotate(var(--r)); }
          4%        { opacity: 1; transform: translateY(-2px) scale(1.01) rotate(var(--r)); }
          5%        { opacity: 1; transform: translateY(0) scale(1) rotate(var(--r)); }
          11%       { transform: translateY(-3px) scale(1) rotate(var(--r)); }
          19%       { opacity: 1; transform: translateY(0) scale(1) rotate(var(--r)); }
          21.5%, 100% { opacity: 0; transform: translateY(-12px) scale(0.97) rotate(var(--r)); }
        }
        .tg-logo { position: relative; width: 28px; height: 28px; border-radius: 8px; display: flex; align-items: center;
          justify-content: center; animation: tgLogo 20s ease-in-out infinite both; }
        .tg-logo svg { width: 15px; height: 15px; }
        .tg-logo img { width: 100%; height: 100%; object-fit: contain; }
        .tg-icon img { width: 100%; height: 100%; object-fit: contain; }
        .tg-logo::after { content: ''; position: absolute; inset: 0; border-radius: inherit; border: 2px solid var(--c);
          opacity: 0; animation: tgRing 20s ease-out infinite both; animation-delay: inherit; }
        /* Lit up while its alert is showing: Whatnot for its two (live, then a new product), then Twitch, YouTube */
        .tg-logo:nth-child(1) { animation-name: tgLogoLong; animation-delay: 0s; }
        .tg-logo:nth-child(2) { animation-delay: 10s; }
        .tg-logo:nth-child(3) { animation-delay: 15s; }
        @keyframes tgLogo {
          0%, 21.5%, 100% { transform: translateY(0) scale(0.9); opacity: 0.5; box-shadow: 0 0 0 rgba(0,0,0,0); }
          4%    { transform: translateY(-5px) scale(1.18); opacity: 1; box-shadow: 0 0 18px var(--c); }
          6%    { transform: translateY(0) scale(1.08); opacity: 1; }
          11%   { transform: translateY(-2px) scale(1.08); opacity: 1; box-shadow: 0 0 12px var(--c); }
          19%   { transform: translateY(0) scale(1.05); opacity: 1; box-shadow: 0 0 8px var(--c); }
        }
        @keyframes tgLogoLong {
          0%, 46.5%, 100% { transform: translateY(0) scale(0.9); opacity: 0.5; box-shadow: 0 0 0 rgba(0,0,0,0); }
          4%    { transform: translateY(-5px) scale(1.18); opacity: 1; box-shadow: 0 0 18px var(--c); }
          6%    { transform: translateY(0) scale(1.08); opacity: 1; }
          26%   { transform: translateY(-2px) scale(1.08); opacity: 1; box-shadow: 0 0 12px var(--c); }
          29%   { transform: translateY(-5px) scale(1.14); opacity: 1; box-shadow: 0 0 18px var(--c); }
          31%   { transform: translateY(0) scale(1.08); opacity: 1; }
          44%   { transform: translateY(0) scale(1.05); opacity: 1; box-shadow: 0 0 8px var(--c); }
        }
        @keyframes tgRing {
          0%, 2%   { opacity: 0; transform: scale(1); }
          3%       { opacity: 0.9; transform: scale(1); }
          10.5%, 100% { opacity: 0; transform: scale(1.9); }
        }
        @media (prefers-reduced-motion: reduce) {
          /* No animation: just the first alert (Whatnot), with its icon lit */
          .tg-slot { animation: none; opacity: 0; }
          .tg-slot:nth-child(1) { opacity: 1; transform: rotate(var(--r)); }
          .tg-logo { animation: none; }
          .tg-logo::after { display: none; }
        }
        .tg-msg { background: #313338; border: 1px solid rgba(255,255,255,0.07); border-radius: 8px; padding: 6px 7px 7px;
          box-shadow: 0 10px 24px rgba(0,0,0,0.55), 0 0 0 1px rgba(0,0,0,0.3); font-family: 'gg sans', 'Noto Sans', system-ui, sans-serif; }
        .tg-av { width: 13px; height: 13px; border-radius: 9999px; object-fit: cover; flex-shrink: 0; display: inline-block; }
        .tg-app { background: #5865f2; color: #fff; font-size: 4.5px; font-weight: 700; padding: 1px 2px; border-radius: 2px; line-height: 1; }
        .tg-head { display: flex; align-items: center; gap: 3px; color: #f2f3f5; font-weight: 800; font-size: 10px; line-height: 1; margin: 5px 0 4px; }
        .tg-sub { color: #dbdee1; font-size: 5.5px; margin: -1px 0 4px; }
        .tg-link { color: #00a8fc; font-size: 5.5px; margin: -1px 0 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .tg-icon { width: 10px; height: 10px; display: inline-flex; flex-shrink: 0; }
        .tg-icon svg { width: 100%; height: 100%; }
        .tg-embed { background: #2b2d31; border-left: 3px solid; border-radius: 4px; padding: 5px 6px 5px; }
        .tg-pfp { width: 16px; height: 16px; border-radius: 9999px; flex-shrink: 0; display: inline-block;
          background: #2c2f33 url('/pfp.jpg') center / cover no-repeat; } /* Cheeks's own profile picture */
        .tg-pfp.xs { width: 7px; height: 7px; margin-right: 2px; vertical-align: -1.5px; }
        .tg-author { color: #f2f3f5; font-weight: 600; font-size: 5px; line-height: 1; margin-bottom: 2px; }
        .tg-provider { color: #b5bac1; font-size: 4.5px; line-height: 1; }
        .tg-author-name { color: #f2f3f5; font-weight: 600; font-size: 5.5px; margin: 2px 0 1px; }
        .tg-title { color: #00a8fc; font-weight: 700; font-size: 6.5px; line-height: 1.25; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .tg-desc { color: #dbdee1; font-weight: 700; font-size: 5.5px; margin-top: 1px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .tg-fields { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 3px 4px; margin-top: 4px; }
        .tg-fname { color: #f2f3f5; font-weight: 700; font-size: 4.5px; line-height: 1.2; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .tg-fval { color: #dbdee1; font-size: 5.5px; line-height: 1.2; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .tg-thumb { position: relative; margin-top: 4px; border-radius: 3px; aspect-ratio: 16 / 8; display: flex; align-items: center; justify-content: center; overflow: hidden; }
        .tg-thumb::before { content: ''; position: absolute; inset: 0; background:
          radial-gradient(circle at 30% 120%, rgba(255,255,255,0.25), transparent 55%),
          repeating-linear-gradient(115deg, rgba(255,255,255,0.05) 0 6px, transparent 6px 12px); }
        .tg-thumb-logo { position: relative; width: 24px; height: 24px; display: flex; color: #fff; filter: drop-shadow(0 2px 6px rgba(0,0,0,0.5)); }
        .tg-thumb-logo svg, .tg-thumb-logo img { width: 100%; height: 100%; object-fit: contain; }
        .tg-badge { position: absolute; top: 3px; left: 3px; background: #e91916; color: #fff; font-size: 4.5px; font-weight: 800; padding: 1px 3px; border-radius: 2px; letter-spacing: 0.05em; }
        .tg-watching { position: absolute; bottom: 3px; left: 3px; background: rgba(0,0,0,0.6); color: #fff; font-size: 4.5px; font-weight: 700; padding: 1px 3px; border-radius: 2px; }
        .tg-duration { position: absolute; bottom: 3px; right: 3px; background: rgba(0,0,0,0.75); color: #fff; font-size: 4.5px; font-weight: 700; padding: 1px 3px; border-radius: 2px; }
        .tg-play { position: relative; width: 22px; height: 15px; border-radius: 4px; background: #ff0000; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 8px rgba(0,0,0,0.5); }
        .tg-play span { width: 0; height: 0; border-style: solid; border-width: 3.5px 0 3.5px 6px; border-color: transparent transparent transparent #fff; margin-left: 1px; }
        .tg-subtitle { color: #dbdee1; font-size: 5px; margin-top: 1px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .tg-photo { background: linear-gradient(160deg, #f4f4f5 0%, #d4d4d8 100%); aspect-ratio: 16 / 9; }
        .tg-photo::before { background: radial-gradient(circle at 50% 110%, rgba(0,0,0,0.18), transparent 60%); }
        .tg-slab { position: relative; width: 34px; padding: 2px 2px 3px; border-radius: 3px; transform: rotate(-6deg);
          background: linear-gradient(135deg, rgba(255,255,255,0.95), rgba(220,225,235,0.85));
          box-shadow: 0 4px 10px rgba(0,0,0,0.35), inset 0 0 0 1px rgba(0,0,0,0.12); }
        .tg-slab-label { display: flex; justify-content: space-between; align-items: center; background: #c8102e; color: #fff;
          border-radius: 1px; padding: 1px 2px; font-size: 3.5px; font-weight: 800; letter-spacing: 0.04em; }
        .tg-slab-label b { font-size: 4.5px; }
        .tg-card { margin-top: 2px; aspect-ratio: 63 / 88; border-radius: 2px; display: flex; align-items: center; justify-content: center;
          background: linear-gradient(135deg, #ff7a18 0%, #ffb347 30%, #ff3cac 60%, #784ba0 80%, #2b86c5 100%);
          box-shadow: inset 0 0 0 1.5px #f5d76e; position: relative; overflow: hidden; }
        .tg-card::after { content: ''; position: absolute; inset: 0; animation: tgShine 3s ease-in-out infinite;
          background: linear-gradient(115deg, transparent 30%, rgba(255,255,255,0.65) 45%, transparent 60%); transform: translateX(-120%); }
        @keyframes tgShine { 0%, 40% { transform: translateX(-120%); } 80%, 100% { transform: translateX(120%); } }
        .tg-card img { width: 12px; height: 12px; filter: brightness(0) invert(1); opacity: 0.9; }
        .tg-footer { color: #b5bac1; font-size: 4.5px; margin-top: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .tg-btn { display: inline-flex; align-items: center; gap: 2px; margin-top: 5px; background: #4e5058; color: #fff; font-size: 5.5px; font-weight: 600; padding: 3px 6px; border-radius: 3px; }
        .tg-btn-icon { width: 7px; height: 7px; display: inline-flex; flex-shrink: 0; }
        .tg-btn-icon svg, .tg-btn-icon img { width: 100%; height: 100%; object-fit: contain; }
      `}</style>

      <TogeBot avatar={avatar} className="tg-bot-banner absolute glow-neutral" />

      <div className="relative px-4 pt-4 text-center" style={{ zIndex: 25 }}>
        <div className="flex items-center justify-center gap-2">
          <div className="relative flex-shrink-0">
            {avatar
              ? <img src={avatar} alt="TOGΞ" className="h-9 w-9 rounded-full object-cover" style={{ background: '#2c2f33', boxShadow: '0 0 0 2px rgba(88,101,242,0.6)' }} />
              : <div className="h-9 w-9 rounded-full flex items-center justify-center" style={{ background: '#5865f2' }}><img src="/pball.svg" alt="" className="h-4 w-4" style={{ filter: 'brightness(0) invert(1)' }} /></div>}
            <span className="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full border-2 border-zinc-900" style={{ background: '#23a55a' }} />
          </div>
          <span className="text-white font-bold" style={{ fontSize: '0.95rem' }}>TOGΞ</span>
          <span className="font-bold rounded px-1 py-0.5 leading-none text-white" style={{ fontSize: '0.5rem', background: '#5865f2' }}>APP</span>
        </div>
        <p className="text-white font-extrabold mt-2 leading-tight" style={{ fontSize: 'clamp(0.95rem, 3.6vw, 1.15rem)' }}>
          Add TOGΞ to your Discord server
        </p>
        <p className="text-zinc-400 mt-1 leading-snug mx-auto" style={{ fontSize: '0.68rem', maxWidth: '22rem' }}>
          Your Whatnot, Twitch and YouTube alerts, posted in your channels the moment you go live, upload, or add products to your store.
        </p>
        {/* Its own link, to the Partner Dashboard (inside the banner's link, so a span that stops the banner's click).
            That page handles everyone: logged out → log in with Discord; not a partner → who to ask; partner → set up */}
        <span role="link" tabIndex={0}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); onDashboard(); }}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); onDashboard(); } }}
          className="inline-flex items-center gap-1.5 mt-2 rounded-full px-2.5 py-1 text-zinc-200 hover:text-white leading-none cursor-pointer transition-colors bg-[#5865f2]/15 hover:bg-[#5865f2]/30 border border-[#5865f2]/40"
          style={{ fontSize: '0.6rem' }}>
          <span aria-hidden="true">🎛️</span> All set up from your own dashboard in seconds <span aria-hidden="true">›</span>
        </span>
        <div className="flex items-center justify-center gap-3 mt-3" aria-label="Whatnot, Twitch and YouTube">
          {ALERTS.filter(a => !a.product).map(a => (
            <span key={a.id} className="tg-logo" title={a.label} style={{ background: a.tile ? 'none' : a.color, color: a.logoColor, '--c': a.color }}>{a.logo}</span>
          ))}
        </div>
      </div>

      <div className="tg-stage mt-3 pointer-events-none" aria-hidden="true" style={{ zIndex: 25 }}>
        {ALERTS.map(a => <div key={a.id} className="tg-slot"><div className="tg-size"><Alert alert={a} avatar={avatar} /></div></div>)}
      </div>

      <div className="relative flex justify-center pb-3.5" style={{ zIndex: 25 }}>
        <span className="inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-white font-semibold bg-[#5865f2] group-hover:bg-[#4752c4] transition-colors shadow-[0_4px_14px_rgba(88,101,242,0.45)]" style={{ fontSize: '0.68rem' }}>
          Find out more <span aria-hidden="true">›</span>
        </span>
      </div>
    </a>
  );
}
